import Handler from '@/core/domain/usecase/handler';
import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { Pump } from '../../domain/model/pump';

export interface CreatePumpRepository {
  (data: object): Promise<Pump>
}

const createPumpRepository = (axios: AxiosInstance): CreatePumpRepository => async (data: object) => {
  try {
    const response: AxiosResponse = await axios.post(`/pump`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createPumpRepository

